var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"div-err"},[_c('img',{attrs:{"src":require("../../../static\\images\\err.png")}}),_vm._v(" "),_c('div',{staticClass:"err"},[_c('span',[_vm._v(_vm._s(_vm.$t("err.err1")))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("err.err2")))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("err.err3")))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2711e47f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/err.vue
// module id = null
// module chunks = 